import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import { usePushNotifications } from '../hooks/usePushNotifications';

/**
 * Notifiche push del browser, nel Profilo. Visibile solo se l'azienda ha
 * abilitato la funzione (vedi Profile.js, che la monta solo in quel caso) —
 * iscrizione/disiscrizione è comunque riverificata lato server
 * (PushController) perché il flag qui è solo UX, non il controllo autorevole.
 */
function KernelPushNotificationsSection() {
  const { t } = useLanguage();
  const { supported, subscribed, loading, error, subscribe, unsubscribe } = usePushNotifications(true);

  if (!supported) return null;

  return (
    <div className="card" style={{ marginTop: 16 }}>
      <div className="card-header">
        <h3>{t('push.title')}</h3>
      </div>
      <div className="card-body">
        <p className="page-subtitle" style={{ marginTop: 0 }}>{t('push.intro')}</p>
        {error && <div className="error-message">{error}</div>}
        <p>
          <span className={`badge ${subscribed ? 'badge-success' : 'badge-warning'}`}>
            {subscribed ? t('push.statusOn') : t('push.statusOff')}
          </span>
        </p>
        <div className="form-actions">
          {subscribed ? (
            <button type="button" className="btn btn-secondary" disabled={loading} onClick={unsubscribe}>
              {loading ? t('push.updating') : t('push.disable')}
            </button>
          ) : (
            <button type="button" className="btn" disabled={loading} onClick={subscribe}>
              {loading ? t('push.updating') : t('push.enable')}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default KernelPushNotificationsSection;
